<template>
  <div class="px-2 font-sans text-black">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Container"
}
</script>

<style scoped>

</style>
